import(/* webpackMode: "eager" */ "/app/code/build/apps/web/src/app/global-error.tsx");
